module.exports = __webpack_public_path__ + "img/portrait-senior-woman-professional-blazer-outdoors-laptop 1.fdaa0c23.png";